import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn, initialsOf } from "@/lib/utils";
import { HEALTH, PLACEMENT_STATUS, fmtDateFr } from "./placementsShared";
import { useLang } from "@/i18n";

export default function PlacementListItem({ item, selected, onClick }) {
  const { tf } = useLang();
  const h = HEALTH[item.health?.state] || HEALTH.NORMAL;
  const a = item.athlete || {};
  const isHistory = item.status !== "ACTIVE";
  return (
    <button
      onClick={onClick}
      data-testid={`placement-item-${item.id}`}
      aria-current={selected ? "true" : undefined}
      className={cn(
        "w-full text-left rounded-2xl border p-3.5 transition-colors",
        selected
          ? "border-foreground/30 bg-secondary/60 ring-1 ring-foreground/15"
          : "border-border dark:border-border bg-card hover:border-foreground/20 dark:hover:border-foreground/25"
      )}
    >
      <div className="flex items-start gap-3">
        <Avatar className="h-10 w-10 shrink-0">
          <AvatarImage src={a.photo_url || undefined} alt="" />
          <AvatarFallback className="text-xs font-semibold bg-secondary">{initialsOf(a.name)}</AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-1.5 min-w-0">
              <span className={cn("h-1.5 w-1.5 rounded-full shrink-0", h.dot)} />
              <span className="text-sm font-semibold truncate">{a.name}</span>
            </div>
            <span className={cn("shrink-0 text-[10px] font-medium rounded-full border px-2 py-0.5",
              isHistory ? "bg-secondary text-muted-foreground border-border" : h.chip)}>
              {isHistory ? tf(PLACEMENT_STATUS[item.status] || item.status) : tf(h.label)}
            </span>
          </div>
          <div className="text-xs text-muted-foreground truncate mt-0.5">
            {[item.club || a.club, a.position].filter(Boolean).join(" · ") || "—"}
          </div>
          <div className="text-[11px] text-muted-foreground/80 mt-1.5 space-y-0.5">
            <div>{item.placement_date ? `${tf("Placé le")} ${fmtDateFr(item.placement_date)}` : tf("Date de placement à compléter")}</div>
            {item.contract_end_date && <div>{tf("Contrat jusqu'en")} {fmtDateFr(item.contract_end_date)}</div>}
          </div>
        </div>
      </div>
    </button>
  );
}
